function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useRef, useState } from "react";
import { withNativeProps } from "../../utils/with-native-props";
import cx from "classnames";
var classPrefix = "tc-barrage";
var BarrageItem = function BarrageItem(_ref) {
  var base = _ref.base,
    setBase = _ref.setBase,
    loop = _ref.loop,
    index = _ref.index,
    item = _ref.item,
    duration = _ref.duration,
    row = _ref.row,
    itemStyle = _ref.itemStyle;
  var _useState = useState("0s"),
    _useState2 = _slicedToArray(_useState, 2),
    animationDelay = _useState2[0],
    setAnimationDelay = _useState2[1];
  var _useState3 = useState("".concat(duration, "s")),
    _useState4 = _slicedToArray(_useState3, 2),
    animationDuration = _useState4[0],
    setAnimationDuration = _useState4[1];
  var _useState5 = useState("running"),
    _useState6 = _slicedToArray(_useState5, 2),
    animationPlayState = _useState6[0],
    setAnimationPlayState = _useState6[1];
  var dom = useRef(null);
  var speed = {
    1: {
      3: 70,
      4: 40,
      5: 25,
      6: 18
    },
    2: {
      3: 110,
      4: 60,
      5: 40,
      6: 25
    },
    3: {
      3: 150,
      4: 80,
      5: 60,
      6: 40
    }
  };
  useEffect(function () {
    var _a;
    var $domWidth = (_a = dom === null || dom === void 0 ? void 0 : dom.current) === null || _a === void 0 ? void 0 : _a.clientWidth;
    if (!!$domWidth) {
      var durationBase = $domWidth / speed[row][duration] / duration;
      setAnimationDuration("".concat(duration, "s"));
      setBase(function (pre) {
        var baseDelay = "".concat(pre, "s");
        var after = pre + durationBase;
        setAnimationDelay(baseDelay);
        setTimeout(function () {
          setAnimationPlayState("paused");
        }, (pre + duration) * 1000);
        return after;
      });
    }
  }, []);
  useEffect(function () {
    if (animationPlayState === "paused") {
      setTimeout(function () {
        setAnimationPlayState("running");
      }, (base - (loop ? duration - (row === 2 ? 0.8 : 0) : 0)) * 1000);
    } else if (base !== 0 && animationPlayState === "running") {
      setTimeout(function () {
        setAnimationPlayState("paused");
      }, duration * 1000);
    }
  }, [animationPlayState]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx("".concat(classPrefix, "-item"), "".concat(classPrefix, "-top-").concat(index % row)),
    ref: dom,
    style: Object.assign({
      animationPlayState: animationPlayState,
      animationDelay: animationDelay,
      animationDuration: animationDuration
    }, itemStyle)
  }, item);
};
var Barrage = function Barrage(props) {
  var _props$row = props.row,
    row = _props$row === void 0 ? 1 : _props$row,
    _props$duration = props.duration,
    duration = _props$duration === void 0 ? 4 : _props$duration,
    style = props.style,
    children = props.children,
    _props$loop = props.loop,
    loop = _props$loop === void 0 ? true : _props$loop,
    itemStyle = props.itemStyle;
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    base = _useState8[0],
    setBase = _useState8[1];
  var height = ["first", "second", "thirdly"];
  var baseProps = {
    className: cx(classPrefix, "".concat(classPrefix, "-").concat(height[row - 1])),
    style: style
  };
  return withNativeProps(props, /*#__PURE__*/React.createElement("div", Object.assign({}, baseProps), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-width")
  }, children.length !== 0 && children.map(function (item, i) {
    return /*#__PURE__*/React.createElement(BarrageItem, {
      loop: loop,
      base: base,
      setBase: setBase,
      itemStyle: itemStyle,
      index: i,
      key: i,
      item: item,
      row: row,
      duration: duration
    });
  }))));
};
Barrage.defaultProps = {
  row: 1,
  duration: 4,
  loop: true
};
export default Barrage;